import React from 'react'

const DeleteConfirmContext = React.createContext({ isOpen: false, toggle: () => null })

export default DeleteConfirmContext
